export const actionTypes = {
  GET_MENUS: "GET_MENUS",
  SET_MENUS: "SET_MENUS",
};

export const actions = {
  getMenus: (payload) => ({
    type: actionTypes.GET_MENUS,
    payload: payload,
  }),

  setMenus: (payload) => ({
    type: actionTypes.SET_MENUS,
    payload: payload,
  }),
};
